import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllBlanchingCookingReponseModel, BlanchingCookingDto, BlanchingCookingReponseModel, LogIdRequest } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw,Repository } from 'typeorm';
import { BlanchingCookingAdapter } from '../dto/blanching-cooking.adapter';
import { BlanchingCookingDTO } from '../dto/blanching-cooking.dto';
import { BlanchingCooking } from '../entities/blanching-cooking.entity';
import { CommonResponse } from '@gtpl/shared-models/masters';


@Injectable()
export class BlanchingCookingService {

    constructor(
        @InjectRepository( BlanchingCooking)
        private blanchingCookingRepository:Repository<BlanchingCooking>,
        private blanchingCookingAdapter: BlanchingCookingAdapter,
        
    ) { }

    async createBlanchingCooking(dto:BlanchingCookingDTO, isUpdate: boolean): Promise<BlanchingCookingReponseModel> {
        
        try {
           
          const convertedEntity: BlanchingCooking = this.blanchingCookingAdapter.convertDtoToEntity(dto,isUpdate);
          const savedEntity: BlanchingCooking = await this.blanchingCookingRepository.save(
            convertedEntity
          );
         
                     if (savedEntity) {
            // generating resposnse
        const response = new BlanchingCookingReponseModel(true,1,isUpdate? 'BlanchingCooking Updated Successfully': 'BlanchingCooking Created Successfully');
        return response;

          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'BlanchingCooking saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          throw error;
        }
      }  


      async getSamplleInfoByLogId(req : LogIdRequest): Promise<AllBlanchingCookingReponseModel> {
        try {
          // retrieves all companies
          const data: BlanchingCookingDTO[] = [];
          const entites: BlanchingCooking[] = await this.blanchingCookingRepository.find({
              where:{ logId: req.productionLogid}
              });
              
             
              if (entites) {
                entites.forEach(sample =>{
                  const gradingMonDto:BlanchingCookingDTO = this.blanchingCookingAdapter.convertEntityToDto(sample)
                  data.push(gradingMonDto)
                })
                  const response = new AllBlanchingCookingReponseModel(true, 11101 , 'Samples retrived Successfully',data);
                  return response;
              }
              else{
                  throw new ErrorResponse(11106,'Something went wrong');
              }
              // generating resposnse
      } catch (err) {
          throw err;
      }
    }


}
